import React from "react";
import ClassNames from "classnames";
import { Link } from "gatsby";
import * as s from "./s.module.scss";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
// content data
import newsStaticContent from "../../../content/news.json";
import {
  getStaticData,
  getLocalizedPath,
  isUrl,
  getParsedData,
} from "../../helperFunctions";

const NewsItemCard = ({
  category,
  imageUrl,
  imageAlt,
  publishedDate,
  labels,
  title,
  summary,
  newspaperName,
  to,
  gatsbyImageUrl,
  hideCategory,
  hideNewsPaper,
  articleOrigin,
  bgWhite,
  locale,
  alias,
  variant,
}) => {
  const categoryResolver = (name) => {
    switch (name) {
      case "AWARDS":
        return "Awards";
      case "PRESS_RELEASES":
        return "Press Releases";
      case "FEATURED_ARTICLES":
        return "Feature Articles";
      case "CSR_ACTIVITIES":
        return "CSR & Activities";
      case "WEBINARS":
        return "Webinars";
      case "IN_THE_NEWS":
        return "In the News";
      case "FINANCIAL_NEWS":
        return "Financial News";
      case "INDUSTRY_INSIGHTS":
        return "Industry Insights";
      case "WHITE_PAPERS":
        return "White Papers";
      case "E_BOOKS":
        return "E-Books";
      default:
        return "Uncategorized";
    }
  };

  const LinkWrapper = ({ to, children }) => {
    return isUrl(to) ? (
      <a
        href={to}
        rel="noopener noreferrer"
        target="_blank"
        aria-label={children}
      >
        {children}
      </a>
    ) : (
      <Link to={to}>{children}</Link>
    );
  };

  return (
    <article
      className={ClassNames(
        variant === "related4cards" ? s.related4cards : s.newsItemCard,
        variant === "related3cards" ? s.related3cards : s.newsItemCard,
        variant === "featuredHome" && s.fitHeight
      )}
    >
      <div className={s.newsItemCardWrapper}>
        <LinkWrapper to={to}>
          {typeof newspaperName === "undefined" && (
            <div className={s.image}>
              {imageUrl && <img src={imageUrl} alt={imageAlt} />}
              {gatsbyImageUrl && (
                <GatsbyImage image={getImage(gatsbyImageUrl)} alt={imageAlt} />
              )}
            </div>
          )}
          <div className={ClassNames(s.content, bgWhite ? s.bgWhite : "")}>
            <div className={s.title}>{title}</div>
            {publishedDate && (
              <div className={s.publishedDate}>{publishedDate}</div>
            )}
            {labels && (
              <div className={s.publishedDate}>
                {labels.map((label, i) => {
                  return (
                    <span className={s.labels} key={i}>
                      {label}
                    </span>
                  );
                })}
              </div>
            )}
            {variant === "featuredHome" && (
              <>
                <p className={s.summaryEllipses}>{getParsedData(summary)}</p>
                <Link
                  to={getLocalizedPath(
                    locale,
                    alias,
                    `/news?page=1&category=${category}`
                  )}
                  onClick={() =>
                    typeof window !== "undefined" ? window.scrollTo(0, 0) : {}
                  }
                >
                  <strong>
                    {getStaticData(newsStaticContent.see_all, locale)}
                  </strong>
                </Link>
              </>
            )}
          </div>
          <div className={ClassNames(s.referral, bgWhite ? s.bgWhite : "")}>
            {!hideCategory && <span>{categoryResolver(category)}</span>}
            {!hideNewsPaper && (
              <span className={s.newspaperName}>
                {articleOrigin ? articleOrigin : null}
              </span>
            )}
          </div>
        </LinkWrapper>
      </div>
    </article>
  );
};

export default NewsItemCard;
